import React, { Component } from "react";

import { connect } from 'react-redux';
import { autobind } from 'core-decorators';
import Promise from 'bluebird';

import styles from './Guest.styles';
import messages from './Guest.messages';

import * as actions from '../../redux/user/actions';
import {
  showIncorrectPasswordError,
  isLoggingIn,
  isLoggedIn
} from '../../redux/user';

import LoopeLogo from '../../components/loope-logo/LoopeLogo';
import ComingSoon from './coming-soon/ComingSoon';

import {Grid, Row, Col, Button, FormGroup, FormControl, ControlLabel} from 'react-bootstrap/lib';
import { Route, Link, Redirect, BrowserRouter as Router } from 'react-router-dom';

import type { State as AppState, Dispatch } from '../../redux/types';
import Login from './login/Login'
import Register from './register/Register'
import ResetPassword from './reset-password/ResetPassword'

type LoginCredentialsObject = {
  email: string;
  password: string;
};

type OwnProps = {
  isLoggedIn: boolean;
  isLoggingIn: boolean;
  isVisible: boolean;
  showInvalidEmailError: boolean;
  showIncorrectPasswordError: boolean;
  showWeakPasswordError: boolean;
  showUnavailableEmailError: boolean;
  onRequestLogin: (credentials: LoginCredentialsObject) => Promise<void>;
  onRequestRegister: (credentials: RegisterCredentialsObject) => Promise<void>;
  onRequestSendPasswordResetEmail: () => Promise<void>;
  clearInvalidEmailError: () => void;
  clearIncorrectPasswordError: () => void;
  clearWeakPasswordError: () => void;
  clearUnavailableEmailError: () => void;
  redirectToDash: () => void;
  redirectToLogin: () => void;
  redirectToRegister: () => void;
  redirectToForgot: () => void;
  path: String;
};

type StateProps = {

};

type DispatchProps = {

};

type Props = OwnProps & StateProps & DispatchProps;

const GUEST_SCREENS = {
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  LOGIN_FORM: 'LOGIN_FORM',
  REGISTRATION_FORM: 'REGISTRATION_FORM',
  COMING_SOON: 'COMING_SOON'
};

type State = {
  email: string;
  password: string;
  screen: $Keys<typeof GUEST_SCREENS>;
};

class Guest extends Component {

  props: Props;
  state = {
    screen: GUEST_SCREENS.LOGIN_FORM,
    email: '',
    password: ''
  };
  loginPromise: ?Promise<void>;

  componentDidMount() {
  }

  componentDidUpdate() {
    if (this.props.isLoggedIn) {
      this.props.redirectToDash()
    }
  }

  componentWillUnmount() {
    this.loginPromise && this.loginPromise.cancel();
  }

  handleShowLogin() {
    this.setState({
      screen: GUEST_SCREENS.LOGIN_FORM
    });
  }

  handleShowComingSoon() {
    this.setState({
      screen: GUEST_SCREENS.COMING_SOON
    });
  }

  render() {
    document.body.classList.add('guest-bg')
    return (
      <div style={styles.container}>
        <div style={styles.logoContainer}>
          <LoopeLogo
            fill="#000"
            width="200"
            height="200"
          />
        </div>
        {this.renderGuestScreen()}
      </div>
    );
  }

  renderComingSoon() {
    return (
      <ComingSoon></ComingSoon>
    )
  }

  renderGuestScreen() {
    if (this.props.path == '/login') {
      return(
        <div>
          {this.renderLogin()}
        </div>
      )
    }
    if (this.props.path == '/register') {
      return(
        <div>
          {this.renderRegister()}
        </div>
      )
    }
    if (this.props.path == '/forgot-password') {
      return(
        <div>
          {this.renderForgotPassword()}
        </div>
      )
    }
  }

  renderLogin() {
    return (
      <Login
        onRequestLogin={this.props.onRequestLogin}
        showIncorrectPasswordError={this.props.showIncorrectPasswordError}
        showInvalidEmailError={this.props.showInvalidEmailError}
        redirectToRegister={this.props.redirectToRegister}
        >
      </Login>
    )
  }

  renderRegister() {
    return(
      <Register
        onRequestRegister={this.props.onRequestRegister}
        showWeakPasswordError={this.props.showWeakPasswordError}
        showInvalidEmailError={this.props.showInvalidEmailError}
        showUnavailableEmailError={this.props.showUnavailableEmailError}
        >

      </Register>
    )
  }

  renderForgotPassword() {
    return(
      <ResetPassword
        onRequestSendPasswordResetEmail={this.props.onRequestSendPasswordResetEmail}
        showInvalidEmailError={this.props.showInvalidEmailError}
        redirectToLogin={this.props.redirectToLogin}
        >

      </ResetPassword>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    showIncorrectPasswordError: showIncorrectPasswordError(state),
    isLoggingIn: isLoggingIn(state),
    isLoggedIn: isLoggedIn(state),
  }
}

export default connect(mapStateToProps, actions)(Guest);



// WEBPACK FOOTER //
// ./src/views/guest/Guest.js